import { createFileRoute } from '@tanstack/react-router'
import { OpsInboxTabContent } from '@/pages/OpsInbox'

export const Route = createFileRoute('/_authenticated/ops-inbox/custom-slot-approvals')({
  component: () => <OpsInboxTabContent filterType="custom_slot_approval" />,
})
